module.exports = __webpack_public_path__ + "5500b848a2a66e260d2942191a0d942a.png";


//////////////////
// WEBPACK FOOTER
// ./src/main/webapp/content/images/navbar.png
// module id = 759
// module chunks = 0